import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';

const auth = getAuth();

export const loginAdmin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Check if user is admin
    const adminRef = ref(database, `admins/${user.uid}`);
    const adminSnapshot = await get(adminRef);
    
    if (!adminSnapshot.exists()) {
      await signOut(auth);
      throw new Error('Unauthorized access');
    }
    
    return user;
  } catch (error) {
    throw error;
  }
};

export const logoutAdmin = () => {
  return signOut(auth);
};

export const getCurrentAdmin = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const adminRef = ref(database, `admins/${user.uid}`);
          const adminSnapshot = await get(adminRef);
          
          if (adminSnapshot.exists()) {
            resolve(user);
          } else {
            resolve(null);
          }
        } catch (error) {
          reject(error);
        }
      } else {
        resolve(null);
      }
      unsubscribe();
    });
  });
}; 